import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    background: (props) => props.aninhado 
      ? theme.palette.backGroundItem.cardInterno + ' !important' 
      : undefined,
    boxShadow: (props) => props.aninhado ? 'none !important' : undefined,
    '&:hover': {
      boxShadow: (props) => props.aninhado ? 'none !important' : undefined,
      transform: (props) => props.aninhado ? 'none !important' : undefined,
    },
  },
  cardActionArea: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  cardContent: {
    padding: theme.spacing(1.5),
    display: (props) => props.tabular ? 'grid' : 'block',
    gridTemplateColumns: (props) => props.tabular ? 'max-content 1fr' : undefined,
    columnGap: (props) => props.tabular ? theme.spacing(1.5) : undefined,
    rowGap: (props) => props.tabular ? theme.spacing(1.1) : undefined,
    alignItems: (props) => props.tabular ? 'baseline' : undefined,
    alignContent: (props) => props.tabular ? 'start' : undefined,
    flexGrow: 1,
  },
  headerTitle: {
    ...theme.typography.subtitle2,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}))

export default useStyles
